import React from 'react';
import Modal from '../../../BaseComponents/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import * as recommendationActions from '../../../../store/recommendationSlice';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ViewRecommendation = ({ isOpen, onClose }: Props) => {
  const { recommendationToView } = useSelector(
    (state: RootState) => state.recommendations
  );
  const dispatch = useDispatch();
  const recommendation = recommendationToView;
 
  return (
    <Modal isOpen={isOpen} onClose={() => {dispatch(recommendationActions.setRecommendationToView(null));}} 
    title={'Recommendation'}
    width={'800px'}>

      <div className='recommendation-modal-form'>
        <div>
          <img alt={recommendation?.title} 
          src={recommendation?.image_url ?? recommendation?.image} 
          width={'100px'} height={'100px'} />
        </div>
        <h3>{recommendation?.title}</h3>
          <p>{recommendation?.description}</p>
      </div>
    </Modal>
  );
};

export default ViewRecommendation;
